var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeedleeyePhoneRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 811.574,
    height: 615.783,
    viewBox: "0 0 811.574 615.783",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7767",
    "data-name": "Group 7767",
    transform: "translate(24559 -6371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7751",
    "data-name": "Group 7751",
    transform: "translate(-24331.723 6371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10532",
    "data-name": "Path 10532",
    d: "M526.269,146.186h0v-92.6A53.591,53.591,0,0,0,472.677,0H276.5a53.591,53.591,0,0,0-53.592,53.591V561.572A53.591,53.591,0,0,0,276.5,615.163H472.675a53.59,53.59,0,0,0,53.591-53.591V212.1h0a3.375,3.375,0,0,0,3.375-3.375V149.562a3.375,3.375,0,0,0-3.375-3.375Z",
    transform: "translate(-218.738)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10533",
    "data-name": "Path 10533",
    d: "M515.748,48.806V563.964c-31.319-1.924-15.389,39.343-40.631,40.64h-200.2a40.653,40.653,0,0,1-40.658-40.646V48.806A40.651,40.651,0,0,1,274.911,8.167h14.765c-4.021,9.887,28.43,13.105,30.917,13.108H423.127c10.674-.014,36.429-10.8,35.489-13.108h16.493a40.644,40.644,0,0,1,40.639,40.624v.015Z",
    transform: "translate(-218.281 0.33)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7750",
    "data-name": "Group 7750",
    transform: "translate(0 157.527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10534",
    "data-name": "Path 10534",
    d: "M221.491,151.421a2.592,2.592,0,0,0-2.589,2.589v20.71a2.589,2.589,0,0,0,5.177,0V154.01A2.592,2.592,0,0,0,221.491,151.421Z",
    transform: "translate(-218.9 -151.421)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10535",
    "data-name": "Path 10535",
    d: "M221.491,211.144a2.591,2.591,0,0,0-2.589,2.589v40.126a2.589,2.589,0,1,0,5.177,0V213.733A2.592,2.592,0,0,0,221.491,211.144Z",
    transform: "translate(-218.9 -149.012)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10536",
    "data-name": "Path 10536",
    d: "M221.491,265.889a2.591,2.591,0,0,0-2.591,2.592v40.126a2.589,2.589,0,1,0,5.177,0V268.481A2.592,2.592,0,0,0,221.491,265.889Z",
    transform: "translate(-218.9 -146.805)",
    fill: "#3f3d56"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7766",
    "data-name": "Group 7766",
    transform: "translate(-24306.852 6563.813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7749",
    "data-name": "Group 7749",
    transform: "translate(31.585 34.667)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1444",
    "data-name": "Rectangle 1444",
    width: 197.988,
    height: 197.988,
    rx: 6,
    transform: "translate(0 0)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1445",
    "data-name": "Rectangle 1445",
    width: 25.423,
    height: 24.652,
    rx: 6,
    transform: "translate(8.474 8.474)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10525",
    "data-name": "Path 10525",
    d: "M4.244,2.83A1.416,1.416,0,0,0,2.83,4.244V21.219a1.416,1.416,0,0,0,1.414,1.414H21.219a1.416,1.416,0,0,0,1.414-1.414V4.244A1.416,1.416,0,0,0,21.219,2.83H4.244m0-2.83H21.219a4.244,4.244,0,0,1,4.244,4.244V21.219a4.244,4.244,0,0,1-4.244,4.244H4.244A4.244,4.244,0,0,1,0,21.219V4.244A4.244,4.244,0,0,1,4.244,0Z",
    transform: "translate(8.502 8.128)",
    fill: "#a47cea"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1446",
    "data-name": "Rectangle 1446",
    width: 14.637,
    height: 13.867,
    rx: 4,
    transform: "translate(13.867 13.867)",
    fill: "#a47cea"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1447",
    "data-name": "Rectangle 1447",
    width: 24.652,
    height: 24.652,
    rx: 6,
    transform: "translate(164.091 8.474)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10526",
    "data-name": "Path 10526",
    d: "M4.244,2.83A1.416,1.416,0,0,0,2.83,4.244V21.219a1.416,1.416,0,0,0,1.414,1.414H21.219a1.416,1.416,0,0,0,1.414-1.414V4.244A1.416,1.416,0,0,0,21.219,2.83H4.244m0-2.83H21.219a4.244,4.244,0,0,1,4.244,4.244V21.219a4.244,4.244,0,0,1-4.244,4.244H4.244A4.244,4.244,0,0,1,0,21.219V4.244A4.244,4.244,0,0,1,4.244,0Z",
    transform: "translate(164.111 8.128)",
    fill: "#a47cea"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1448",
    "data-name": "Rectangle 1448",
    width: 13.096,
    height: 13.867,
    rx: 4,
    transform: "translate(170.254 13.867)",
    fill: "#a47cea"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1449",
    "data-name": "Rectangle 1449",
    width: 25.423,
    height: 26.193,
    rx: 6,
    transform: "translate(8.474 163.321)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10527",
    "data-name": "Path 10527",
    d: "M4.244,2.83A1.416,1.416,0,0,0,2.83,4.244V21.219a1.416,1.416,0,0,0,1.414,1.414H21.219a1.416,1.416,0,0,0,1.414-1.414V4.244A1.416,1.416,0,0,0,21.219,2.83H4.244m0-2.83H21.219a4.244,4.244,0,0,1,4.244,4.244V21.219a4.244,4.244,0,0,1-4.244,4.244H4.244A4.244,4.244,0,0,1,0,21.219V4.244A4.244,4.244,0,0,1,4.244,0Z",
    transform: "translate(8.502 163.737)",
    fill: "#a47cea"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1450",
    "data-name": "Rectangle 1450",
    width: 14.637,
    height: 14.637,
    rx: 4,
    transform: "translate(13.867 169.484)",
    fill: "#a47cea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10528",
    "data-name": "Path 10528",
    d: "M86.439,204.389v-3.025H80.39V189.269h6.049V171.122h6.049v-6.049H80.393v-6.049H56.2v-6.049h6.049v-6.049H50.149v12.1H44.095v-6.049H32v-6.049H44.095V134.827H38.049v6.049H32V128.781H44.095v6.049h6.049v6.049h6.049V134.83h6.049v6.049H74.337V134.83H68.293v-6.049H50.146v-6.049H68.293v-6.049H50.146v-6.049H44.095v6.049H32V98.536h6.049v6.049H74.342V98.536H68.293V92.487H56.2v6.049H50.146V92.487H38.051V80.392H50.146V92.487H56.2V86.438H68.29V80.39h6.049v6.049H68.293v6.049h6.049v6.049h6.049V86.442H86.44V80.39H80.39V62.244H92.485v6.049h6.049v6.049H92.485v6.049h6.049v36.293H86.439v-6.049H80.39v6.049H74.341v6.049H68.293v6.049h6.049v6.049h6.049v6.049H92.486V134.83H86.437v-6.049H80.39v-6.049H92.485v12.095h6.049V122.732h6.049v12.095h6.049V116.683h6.049v-6.049h6.049v6.049h-6.049v6.049h6.049v6.049h18.146v-6.049h-6.049v-6.049h-6.049V104.588h-6.049V98.539h6.049V92.49h6.049V86.441h-6.049V80.39h-6.049V92.485H116.68V86.436h-6.049v6.049h-6.046V86.436h6.049V80.39h-6.049V62.244H98.536V56.2h6.049v6.049h6.049v-24.2h6.049V50.144h12.095V44.095h-6.049V32h12.095v6.049h-6.049v6.046H140.87V38.049h6.049v6.046H140.87V56.19h6.049V74.341h6.049V68.293h6.049V98.536h12.095V92.487h-6.049V80.392h12.095V98.539h12.095V92.49H183.2V80.395h6.049V92.49H195.3V86.441H207.4V98.535h-6.049V92.486H195.3v6.049H189.25v18.146H195.3v6.049H189.25v6.049H177.155v6.049h-6.049v6.049H159.011v-6.049h-6.049V128.78h-6.049v12.095h6.049v6.049h18.146v6.049H183.2v-6.049h-6.049v-6.049H183.2v-6.049h6.049v6.049H195.3v6.049h6.049V134.829H195.3V128.78H207.4v18.146h-6.049v12.095h6.068v12.095h-6.049v18.146h6.049v6.049H189.267v12.095H171.122v-6.049h12.095v-6.049H171.122V183.213h-6.049v12.095h-6.049v6.049h6.049v6.058H152.978V189.267h-6.049v12.095h-6.049v-6.049H134.83V171.122h6.049v18.146h6.049V171.122h6.049V159.027h-6.049v-6.049h-6.049v-6.049h6.049v-6.049h-6.049V134.83H134.83v24.2h6.049v6.049H128.784V177.17h-6.049v12.095h6.049v6.049h-6.049v6.049H134.83v6.053H122.735v-6.049h-6.049v-6.049h-6.049v12.095h-24.2v-3.025Zm18.146-9.073v-6.049h6.049V171.122H98.539v6.049h6.049v6.049H92.493v6.049H86.444v6.049h6.049v6.049h12.095v-6.049Zm84.683-6.049v-6.049h6.049V171.123h6.049v-6.049h-6.049V146.926h-6.049v18.146h6.049v6.049h-6.049v6.049h-6.049v18.146h6.049v-6.049Zm-30.244-3.025v-3.025h-6.049v6.049h6.049v-3.025Zm-36.293-12.095v-3.025h-6.049v6.049h6.049v-3.025Zm54.439-6.049v-9.075H159.023V177.17H177.17V168.1Zm-22.061,0,2.86-9.916,20.8-.924-.693,20.583H157.97Zm-38.427-6.049v-3.025h12.095v-6.049H116.683v-6.049h-6.049v6.049h6.049v6.049H104.588v-6.049H98.539v6.049H92.49v-6.049H86.441v-6.049H80.39v-6.049H74.341v6.049H68.293v6.049h6.049v-6.049h6.049v6.049H86.44v6.049h6.049v6.049h24.2v-3.026ZM98.537,143.9v-3.025H92.488v6.049h6.049V143.9Zm30.244-3.025V134.83H116.686v6.049h6.049v6.049h6.049v-6.049Zm36.293-9.073v-3.025h-6.049v6.049h6.049v-3.025Zm12.095-6.049v-3.025h6.049V104.585h-6.049v6.049h-6.049v6.049H165.07v-6.049H152.975v-6.049h-6.049V98.536h6.049V80.39h-6.049V74.341h-6.049V68.293h-6.049v6.049h-6.049V56.2h6.049v6.049h6.049V56.2h-6.049V50.146h-6.049V56.2H122.73V74.341h6.049V80.39h6.049V74.341h6.049V92.487h-6.049v6.049h-6.049v6.049h6.049V116.68h6.049v-6.049h12.095v6.049h6.049v6.049h12.095v6.049h6.049v-3.023Zm-6.049-6.049v-3.025h6.049v6.049h-6.049v-3.025ZM74.341,113.66l6.049-3.025v-6.051H74.341v6.049H68.293v6.049h6.049V113.66Zm18.146-12.095V98.541H86.438v6.049h6.049Zm0-30.244V68.293H86.438v6.049h6.049V71.317Zm24.2-3.025V62.244h-6.049V74.339h6.049V68.293ZM146.926,38.054Zm54.439,166.341V201.37h6.051v6.046h-6.049v-3.025Zm0-87.707v-6.049h-6.049v-6.053h6.049v6.049h6.051v12.095h-6.049V116.68ZM74.341,74.341ZM80.39,53.17V50.146h6.049V56.2H80.39V53.171Zm12.095-6.049V44.095H86.436V32h6.049v6.049h6.049V32h6.049v6.049H98.534V50.144H92.485V47.122Z",
    transform: "translate(-21.376 -18.213)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1451",
    "data-name": "Rectangle 1451",
    transform: "translate(7.704 10.015)",
    fill: "none",
    stroke: "#090814",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 246.522,
    height: 247.292,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 241.522,
    height: 242.292,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1452",
    "data-name": "Rectangle 1452",
    width: 13.867,
    height: 197.988,
    transform: "translate(247.293 38.519)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1453",
    "data-name": "Rectangle 1453",
    width: 13.867,
    height: 197.988,
    transform: "translate(0 38.519)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1454",
    "data-name": "Rectangle 1454",
    width: 197.988,
    height: 20.8,
    transform: "translate(32.356)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1455",
    "data-name": "Rectangle 1455",
    width: 197.988,
    height: 20.8,
    transform: "translate(32.356 246.522)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_407",
    "data-name": "Ellipse 407",
    cx: 11.017,
    cy: 11.017,
    r: 11.017,
    transform: "translate(-24241.648 6697.474)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1456",
    "data-name": "Rectangle 1456",
    width: 811.574,
    height: 1.75,
    transform: "translate(-24559 6985.032)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7760",
    "data-name": "Group 7760",
    transform: "translate(-24000.795 6501.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10550",
    "data-name": "Path 10550",
    d: "M791.245,369.419h0a15.743,15.743,0,0,0-2.054-8.465V329.69H775.019l-1.389,30.947a15.955,15.955,0,0,0-2.556,8.37c-.218,7.305,4.121,13.321,9.689,13.437s10.261-5.712,10.479-13.017Z",
    transform: "translate(-625.268 -110.173)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10551",
    "data-name": "Path 10551",
    d: "M664.819,365.783c.838,7.028,5.7,12.353,10.851,11.889s8.653-6.537,7.814-13.566a16.191,16.191,0,0,0-3.1-7.908L676.4,326.447l-16.047,1.919,5.63,29.119a15.528,15.528,0,0,0-1.167,8.292h0v.006Z",
    transform: "translate(-632.122 -110.303)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7757",
    "data-name": "Group 7757",
    transform: "translate(54.785 411.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10552",
    "data-name": "Path 10552",
    d: "M721.522,590.4H704.757l-4.611-64.3,17.73,2.541Z",
    transform: "translate(-664.486 -526.105)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10553",
    "data-name": "Path 10553",
    d: "M672.334,583.368h0a14.107,14.107,0,0,0-.781,4.642h0a5.573,5.573,0,0,0,5.573,5.573h50.853a3.8,3.8,0,0,0,3.8-3.8v-2.121s2.516-6.363-2.663-14.2c0,0-6.437,6.141-16.055-3.478l-2.837-5.139-20.532,15.016-11.38,1.4c-2.49.306-4.7-.047-5.978,2.109h0Z",
    transform: "translate(-671.553 -519.444)",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7758",
    "data-name": "Group 7758",
    transform: "translate(0 411.208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10554",
    "data-name": "Path 10554",
    d: "M721.522,590.4H704.757l-4.611-64.3,17.73,2.541Z",
    transform: "translate(-664.486 -526.105)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10555",
    "data-name": "Path 10555",
    d: "M672.334,583.368h0a14.107,14.107,0,0,0-.781,4.642h0a5.573,5.573,0,0,0,5.573,5.573h50.853a3.8,3.8,0,0,0,3.8-3.8v-2.121s2.516-6.363-2.663-14.2c0,0-6.437,6.141-16.055-3.478l-2.837-5.139-20.532,15.016-11.38,1.4c-2.49.306-4.7-.047-5.978,2.109h0Z",
    transform: "translate(-671.553 -519.444)",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10556",
    "data-name": "Path 10556",
    d: "M17.92,50.821A26.065,26.065,0,1,1,41.706,46.9l1.045-.113,3.422,25.991L17.92,77.218Z",
    transform: "translate(58.467 6.716)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10557",
    "data-name": "Path 10557",
    d: "M685.214,201.6l6.3,131.243,49.347-1.05,8.4-114.443-10.5-29.4-3.62-3.468s-7.457,7.9-16.56,8.683-20.756-5.216-20.756-5.216Z",
    transform: "translate(-628.731 -116.028)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10558",
    "data-name": "Path 10558",
    d: "M24.752,196.771c-4.122-2.132-4.464-12.409-3.458-23.679l-13.63.789L0,95.107S4.948,36.069,7.109,22.715c1.073-6.63,8.953-9.342,16.615-10.384A78.333,78.333,0,0,1,40.032,6.214s4.651-6.917,11.8,0,8.134,28.472,16.8,27.686S83.266,0,83.266,0s25.691,8.279,39.817,17.673c4.229,1.313,7.6,3.64,8.563,7.613C134.842,38.429,144.39,96.9,144.39,96.9L142.9,176.029l-19.153.389-3.287-72.239-7.145-22.087-1.888,9.167-2.1,27.3,7.945,29.27s-3.895,14.63,2.147,25.014c3.74,17.952-4.843,18.168-4.843,18.168S62.205,198.144,37,198.144C31.067,198.142,26.639,197.747,24.752,196.771ZM24.424,100.5l1.42,43.317c.553-2.69.922-4.306.922-4.306l3.279-30.869L27.821,86.287Z",
    transform: "translate(22.748 67.802)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7759",
    "data-name": "Group 7759",
    transform: "translate(54.492 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10559",
    "data-name": "Path 10559",
    d: "M732.473,169.752c1.435.244,3.121-3.234,4.731-6.624,3.371-7.094,5.514-11.6,5.677-17.977.139-5.433-1.37-4.007-2.839-16.085-.484-3.984-7.286-3.976-8.676-5.867-2.34-3.2,1.25-4.513-4.572-6.433-10.9-3.6-15.834,1.99-22.759,2.471-.175.012-3.608,3.369-5.525,3.543-3.359.3-8.208-.219-10.377-5.337-2.029-4.786-3.376,9.2-1.561,10.929a4.464,4.464,0,0,1,1.561,2.977c.077.3-3.615-4.335-4.684-1.416-.769,2.1,1.568,11.046,3.524,11.452,1.635.34,5.718-3.175,4.813-.966-2.092,5.125,10.487,8.392,25.546-1.892.534-.369.03.217,1.892,4.731,2.349,5.693,2.879,6,2.839,7.569-.092,3.394-2.638,4.394-1.892,6.624a4.583,4.583,0,0,0,4.731,2.839c2-.412,2.339-2.882,3.781-2.839,1.239.038,2.708,1.9,2.839,3.781.277,3.966-5.594,5.056-6.624,10.408C724.323,174.665,731.154,169.527,732.473,169.752Z",
    transform: "translate(-683.3 -115.567)",
    fill: "#090814"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10560",
    "data-name": "Path 10560",
    d: "M453.253,256.712l81.371-3.7,8.137,47.343-5.177,16.279-4.439,18.494-13.315,65.1-11.1,96.162h-23.55l-.492-91.358,1.752-79.152-21.88,66.249v23.629l-9.241,82.713L434.7,496.389s-3.117-59.6-1.716-104.261,7.32-74.386,7.32-74.386V305.166l2.959-5.918Z",
    transform: "translate(-398.132 -36.197)",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7765",
    "data-name": "Group 7765",
    transform: "translate(-24473.693 6525.822)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10561",
    "data-name": "Path 10561",
    d: "M6.206,57.113,8.527,39.465a22.042,22.042,0,1,1,21.889,2.984l2.557,20.789Z",
    transform: "translate(32.272 10.876)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7761",
    "data-name": "Group 7761",
    transform: "translate(35.274 394.831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10562",
    "data-name": "Path 10562",
    d: "M106.231,527.613l14.808.324-2.69,30.581H104.41Z",
    transform: "translate(-96.224 -527.613)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10563",
    "data-name": "Path 10563",
    d: "M140.28,581.986h0a2.433,2.433,0,0,0-1.6-2.229l-10.939-4.319L120.281,561.6l-.113-13.926L104.8,546.234l-2.223,8.874s4.577-.546-1.073,3.375-2.93,11.592-2.93,11.592L97.34,584.412H107.51l.546-8.916c7.911,2.683,9.85,8.916,9.85,8.916h19.717a2.552,2.552,0,0,0,2.656-2.427Z",
    transform: "translate(-97.34 -520.415)",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7762",
    "data-name": "Group 7762",
    transform: "translate(54.292 395.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10564",
    "data-name": "Path 10564",
    d: "M128.4,528.468h19.675l-8.823,40.839-14.67,8.084Z",
    transform: "translate(-117.259 -528.468)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10565",
    "data-name": "Path 10565",
    d: "M163.951,580.191h0a2.513,2.513,0,0,0-1.768-2.284l-12.057-4.427-2.859-4.931-5.359-6.118-.124-14.276-16.939-1.48-2.449,9.094s5.044-.56-1.183,3.459-3.228,11.879-3.228,11.879L116.622,585.8h11.209l.6-9.138c8.718,2.749,10.857,9.138,10.857,9.138h21.729c1.619,0,2.932-4.235,2.932-5.61h0Z",
    transform: "translate(-116.622 -520.052)",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10566",
    "data-name": "Path 10566",
    d: "M111.034,292.991h0L95.509,330.065a72.3,72.3,0,0,0-4.738,39.144s8.473,46.323,10.359,91.855-2.813,90.255-2.813,90.255H128.15l13.027-162.174,2.569,64.06-21.378,99.945,24.237,1.982L176.062,450.8l4.888-67.313-10.6-55.093-59.32-35.4h0Z",
    transform: "translate(-61.326 -142.244)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10567",
    "data-name": "Path 10567",
    d: "M92.705,343.222c-17.089,48.658,4.684,86.992.166,62.263-3.777-20.667,60.57-83.555,79.939-70.587-.406-2.1-15.9-44.092-16-46.27-.369-8.415,2.9-17.46,6.71-26.449,2.5-6.945,2.541-12.911.121-17.724a17.742,17.742,0,0,0-9.794-8.465L141.16,220.662c-3.306-3.99-8.182-12.6-13.363-12.566L99.985,207.1c-.795-.478-10.561,7.92-20.069,12.041-10.313,4.474-8.185,16.682-8.159,16.838l.024.146.113.1,15.159,44.623,13.7,12.836c-.694,2.012-.52,3.523.779,4.389-1.866,1.383-10.163,42.661-8.823,44.107v1.036h0Z",
    transform: "translate(-62.065 -145.708)",
    fill: "#a47cea"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7763",
    "data-name": "Group 7763",
    transform: "translate(56.06 68.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10568",
    "data-name": "Path 10568",
    d: "M236.581,253.381a17.138,17.138,0,0,0-6.595,4.69l-27.064,9.278,4.8,12.748,26.938-10.784a17.139,17.139,0,0,0,7.978-1.358c6.325-2.625,10.1-8.014,8.427-12.039s-8.152-5.16-14.479-2.535Z",
    transform: "translate(-118.051 -214.131)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10569",
    "data-name": "Path 10569",
    d: "M116.321,221.371h0l50.243,67.818,58.894-16.219-2.56-15.364L178.05,266.1l-25.019-38.463c-8.169-15.792-24.272-18.972-36.711-6.271h0Z",
    transform: "translate(-116.321 -213.525)",
    fill: "#a47cea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7764",
    "data-name": "Group 7764",
    transform: "translate(0 80.722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10570",
    "data-name": "Path 10570",
    d: "M139.693,329.8a16.77,16.77,0,0,0-7.829-1.185L106.511,316.74l-5.3,12.229L127.5,339.7a16.77,16.77,0,0,0,6.538,4.469c6.234,2.453,12.555,1.227,14.116-2.741s-2.227-9.173-8.462-11.626h0Z",
    transform: "translate(-62.403 -224.088)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10571",
    "data-name": "Path 10571",
    d: "M73.429,225.7h0L62.434,309.377l53.622,29.261,8.835-12.827L86.738,300.756l8.735-45.045c5.1-17.034-4.271-30.51-22.042-30.018h0Z",
    transform: "translate(-62.434 -225.68)",
    fill: "#a47cea"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10572",
    "data-name": "Path 10572",
    d: "M704.639,87.468S705.323,96.636,715,96.9c13.089.35,19.151,1.053,19.151,1.053S718.4,55.789,725.221,60.338s24.921-13.2,24.921-13.2l5.471,8.748s12.828-4.644-1.389-16.019c0,0-16.963-13.114-34.971-5.239S704.639,87.468,704.639,87.468Z",
    transform: "translate(-683.017 -32.105)",
    fill: "#090814"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedleeyePhoneRight);
export default __webpack_public_path__ + "static/media/needleeye-phone-right.b8d0bcbfd3143274d1fb4c3b8db7bc58.svg";
export { ForwardRef as ReactComponent };